import React from "react"
import { AuthProvider } from "./services/auth/"
import { SnackbarProvider } from "./services/snackbar"
import { ThemeProviderWrapper } from "./services/ThemeContext"
import { Router } from "./Routes"
import { StaticProvider } from "./services/static/staticProvider"
import { DLQueueProvider } from "./services/dlqueue"

const App = (): React.ReactElement => (
  <SnackbarProvider>
    <ThemeProviderWrapper>
      <StaticProvider>
        <AuthProvider>
          <DLQueueProvider>
            <Router />
          </DLQueueProvider>
        </AuthProvider>
      </StaticProvider>
    </ThemeProviderWrapper>
  </SnackbarProvider>
)

export default App
